var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-3_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00CA69",
  d: "M60 30C60 13.432 46.569 0 30 0 13.432 0 0 13.432 0 30c0 16.569 13.432 30 30 30 16.569 0 30-13.431 30-30"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5C400",
  d: "M30 47.705c-4.75 0-9.273-1.465-12.733-4.122-3.817-2.933-6.005-7.128-6.005-11.506 0-13.225 2.19-8.572 6.005-11.504 3.46-2.658 7.98-4.123 12.733-4.123 4.752 0 9.272 1.465 12.732 4.123 3.818 2.932 6.005-1.05 6.005 11.504 0 4.378-2.19 8.573-6.005 11.506-3.46 2.657-7.98 4.122-12.732 4.122m0-20.655c-4.795 0-8.138 2.65-8.138 5.027s3.343 5.028 8.138 5.028 8.137-2.65 8.137-5.028S34.795 27.05 30 27.05"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#794B37",
  d: "M30.005 42.375c-.943-.127-1.82-.56-2.793-.977-1.522-.653-2.602.502-4.075.447-.497-.017-.972-.22-1.385-.495-.577-.385-1.052-.907-1.59-1.345-.587-.477-1.12-1.07-1.805-1.415-.882-.445-1.797-.145-2.397-1.115-.305-.492-.435-1.072-.625-1.623-.27-.787-.685-1.522-1.325-2.067-.615-.522-1.32-.932-1.653-1.71a13.45 13.45 0 0 1-1.097-5.293c0-6.907 4.875-11.86 11.36-13.55q.738-.192 1.492-.334c6.058-1.15 13.745-.925 18.835 2.987 3.818 2.932 5.788 6.52 5.788 10.897 0 1.39-.22 2.76-.645 4.08a14 14 0 0 1-.785 1.933c-.423.852-.398 1.953-1.045 2.69-.655.748-1.745.758-2.585 1.18-1.033.52-1.763 1.56-2.45 2.455-.6.78-1.16 1.79-2.235 1.95-.71.105-1.383-.325-2.09-.45-1.043-.185-2.448.395-3.385.82-.553.253-1.085.558-1.663.75a4 4 0 0 1-1.855.183zm-.378-20.905-.177.015c-1.51.163-2.898.668-4.325 1.155-.543.185-1.095.375-1.57.697-.665.453-1.14 1.148-1.418 1.903-.24.66-.337 1.385-.2 2.073.225 1.135 1.048 2.07 1.993 2.74 1.435 1.017 3.18 1.532 4.93 1.694 2.462.23 5.04-.237 7.087-1.625.648-.437 1.243-.972 1.655-1.637.41-.665.625-1.473.488-2.24-.193-1.08-1.028-1.928-1.888-2.61-.547-.435-1.157-.858-1.852-1.01-.77-.165-1.59-.043-2.34-.302-.89-.31-1.345-.925-2.383-.855z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "M30.05 32.51h-1.308v2.948h1.308zM31.945 35.908l-.344 1.261 2.843.776.345-1.261z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m27.973 38.003-.798 1.035 2.335 1.8.798-1.037zM35.468 31.187l-1.1.707 1.595 2.48 1.1-.708zM38.75 36.475h-1.308v2.947h1.308z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m32.218 16.025-1.282-.257-.58 2.89 1.281.257zM39.146 31.309l-.863.982 2.214 1.945.863-.982zM17.41 22.829l-.524 1.197 2.7 1.182.524-1.198zM21.769 33.304l-.863.983 2.214 1.945.863-.982z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m21.807 37.41.276 1.278 2.88-.62-.274-1.279z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m39.145 21.097-.863.982 2.214 1.946.863-.982zM27.663 13.209l-.863.982 1.73 1.52.862-.982zM23.16 20.365l-.863.982 1.73 1.52.863-.982z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "M22.215 27.065h-1.308v2.302h1.308z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "M14.697 23.798H13.39V26.1h1.307zM34.743 12.73l-.863.983 1.73 1.52.862-.982zM44.306 31.725 43.028 32l.62 2.882 1.279-.276z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m44.296 27.646-1.1-.707-1.593 2.48 1.1.707z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m24.804 30.222-1.1-.707-1.247 1.94 1.1.706z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "M25.215 16.548h-1.308v2.305h1.308zM19.863 17.576l-1.198-.524-.924 2.112 1.198.524zM17.078 20.944l-.545-1.19-2.096.962.545 1.188zM19.32 33.041l-1.1-.706-1.246 1.938 1.1.707z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m16.429 30.963-.872-.975-1.718 1.536.871.975z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43D6DF",
  d: "m36.997 20.204-.778-1.051-1.859 1.376.778 1.05zM40.326 16.024l-.778-1.051-2.369 1.754.778 1.05zM40.225 28.658V27.35h-2.948v1.307zM44.69 20.833v-1.308h-2.948v1.308zM19.622 28.215v-1.308h-2.947v1.308z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F982C9",
  d: "m46.87 26.664.257-1.282-2.89-.58-.257 1.282z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-3_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
})))));
export { SvgAvatar3 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-3.6c25527dbaa0cd988525.svg";